"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Car, Shield, Clock, ArrowRight } from "lucide-react";
const services = [{
  id: 1,
  icon: Car,
  title: "Luxury Black Car Service",
  description: "Premium sedans with professional chauffeurs for business executives and VIP clients seeking ultimate comfort and style.",
  link: "/ServicesPage"
}, {
  id: 2,
  icon: Shield,
  title: "SUV Chauffeur Service",
  description: "Spacious, high-end SUVs perfect for groups, families, or clients requiring extra luggage capacity and privacy.",
  link: "/ServicesPage"
}, {
  id: 3,
  icon: Clock,
  title: "Airport & Event Transportation",
  description: "Punctual transfers for flights, corporate events, and special occasions with 24/7 availability across Los Angeles.",
  link: "/ServicesPage"
}];
export default function OurServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return;
}